import React from 'react';
import { Link, Route, Router } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

const backdrop = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
}

const modalVariant = {
    hidden: { y: "-100vh", opacity: 0 },
    visible: {
        y: "200px",
        opacity: 1,
        transition: { delay: 0.5 }
    },
}

const Modal = ({ modal, showModal }) => {
    return (
        <AnimatePresence >
            {modal &&
                <motion.div
                    className="backdrop"
                    variants={backdrop}
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                >
                    <motion.div className="modal"
                        variants={modalVariant}
                    >
                        <p>Want to make another Pizza?</p>
                        <Link to="/">
                            <button onClick={() => { showModal(false) }}>Start Again</button>
                        </Link>
                    </motion.div>
                </motion.div>
            }
        </AnimatePresence>
    )
}

export default Modal;